import { z } from 'zod';
import { WorkflowExecutionStatusName } from '@temporalio/client/lib';

const stringToJSONSchema = z
	.string()
	.transform((str, ctx): z.infer<ReturnType<typeof JSON.parse>> => {
		try {
			return JSON.parse(str);
		} catch {
			ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
			return z.NEVER;
		}
	});

export const ZBusinessError = stringToJSONSchema.pipe(
	z.object({
		error: z.object({
			code: z.number(),
			message: z.string().optional(),
			stack: z.string().optional(),
		}),
	})
);

export const WorkflowExecutionStatus: Record<
	WorkflowExecutionStatusName,
	WorkflowExecutionStatusName
> = {
	UNSPECIFIED: 'UNSPECIFIED',
	RUNNING: 'RUNNING',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	CANCELLED: 'CANCELLED',
	TERMINATED: 'TERMINATED',
	CONTINUED_AS_NEW: 'CONTINUED_AS_NEW',
	TIMED_OUT: 'TIMED_OUT',
	UNKNOWN: 'UNKNOWN',
};
